// extracted by mini-css-extract-plugin
export default {"linkHolder":"SignUp_linkHolder__yuSP+"};